import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import {firestore} from "../../config/firebaseConfig";
import {cartOrderCollection} from 'src/constant/firestore';
import {isFunction} from "lodash";

export const updateQuantityToBuy = (itemId, cartId, newQuantity) => {
    return {type: 'purchaseCartList/updateQuantityToBuy', payload: {itemId, cartId, newQuantity}};
}

export const AddNewQuatityToBuy = (itemId, cartId, newQuantity,lastQuantity, callback = null) => {
    return async (dispatch) => {
        try {
            const batch = firestore.batch();
            const ref = cartOrderCollection.doc(cartId).collection("cart_items").doc(itemId);
            batch.update(ref, {QuantityToBuy: newQuantity/*, RestQtyToBuy: lastQuantity- newQuantity*/});
            await batch.commit();

            dispatch(updateQuantityToBuy(itemId, cartId, newQuantity));

            isFunction(callback) && callback();
        } catch (error) {
            console.log(error);
        }
    };
};

export const purchaseCartList = createAsyncThunk(
    'purchaseCartList/fetch',
    async ({ docId, onResolve }, thunkAPI) => {
      const handleResolve = (args) => onResolve && onResolve(args);
  
      return new Promise(async (resolve, reject) => {
        try {
          const itemsCollectionRef = firestore.collection('items');
          const querySnapshot = await itemsCollectionRef
            .where(`Vendors.${docId}.InCart`, '==', 'yes')
            .get();
  
          const result = querySnapshot.docs.map((doc) => doc.data());
  
          resolve({
            [docId]: result,
          });
  
          handleResolve(result);
        } catch (e) {
          reject(e);
          handleResolve([]);
        }
      });
    }
  );
  

const purchaseCartListSlice = createSlice({
    name: 'purchaseCartList',
    initialState: {
        ref: {},
        cartId: null
    },
    reducers: {
        updateRef:(state,{payload})=>{
            const {CartId,newData} = payload
            state.ref[CartId] = newData
        },
        setCartId:(state,action) =>{
            state.cartId = action.payload;
        },
        // other reducers in the slice
        updateQuantityToBuy: (state, action) => {

            const {itemId, cartId, newQuantity} = action.payload;
            const cartIndex = state.ref[cartId]?.findIndex((cart) => cart.id === cartId);
            if (cartIndex !== -1) {
                const itemIndex = state.ref[cartId][cartIndex].items.findIndex((item) => item.id === itemId);
                if (itemIndex !== -1) {
                    state.ref[cartId][cartIndex].items[itemIndex].QuantityToBuy = newQuantity;
                }
            }
        },
    },
    extraReducers: builder => {
        builder.addCase(purchaseCartList.fulfilled, (state, action) => {
            state.ref = {...state.ref, ...action.payload}
        })
    }
})

export const {setCartId,updateRef} = purchaseCartListSlice.actions;
export default purchaseCartListSlice.reducer;

export const selectPurchaseCartList = state => state.purchaseCartListRef.ref;

